import { render, staticRenderFns } from "./QuotationStatus.vue?vue&type=template&id=52b6dc83&scoped=true"
import script from "./QuotationStatus.vue?vue&type=script&lang=js"
export * from "./QuotationStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b6dc83",
  null
  
)

export default component.exports